import { PropsWithChildren, useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export function RouteBodyClass({ children }: PropsWithChildren) {
  const location = useLocation();

  useEffect(() => {
    document.body.dataset.route = location.pathname;

    return () => {
      delete document.body.dataset.route;
    };
  }, [location]);

  return <>{children}</>;
}
